// extracted by mini-css-extract-plugin
export default {"normal":"Index_normal__DA6py","normalH5":"Index_normalH5__khW-D"};